import styled from 'styled-components';

import { Button } from '@pkg/components/Sections/Profile/Buttons';
import { styledTypography } from '@pkg/primitives';

export const Wrapper = styled.div`
    background: ${({ theme }) => theme.shades.white[10]};
    justify-content: space-between;
    border-radius: 8px;
    display: flex;
    padding: 10px 12px;
    gap: 5px;

    strong {
        color: ${({ theme }) => theme.shades.white[80]};
    }
    span {
        color: ${({ theme }) => theme.shades.white[50]};
    }
`;

export const Content = styled.div<{ $alignRight?: boolean }>`
    justify-content: space-between;
    flex-direction: column;
    align-items: ${({ $alignRight }) => ($alignRight ? 'flex-end' : 'flex-start')};
    display: flex;
    width: 50%;
`;

export const WinnerIdWrapper = styled.div`
    color: ${({ theme }) => theme.shades.white[60]};
    margin: 0;
`;

export const Header = styled.h1`
    ${styledTypography.allianceBase};
    font-weight: 700;
    font-size: 20px;
`;

export const PlayerWrapper = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
`;

export const PlayerButton = styled(Button)`
    display: flex;
`;
